import app_data  from "../Data/App_data/app_fixed_data.json";
export const isProfileLimitReached = (profiles, profile_limit) => {
  return profiles.length >= profile_limit;
};

export const isDuplicateProfileType = (profiles, profileType) => {
  return profiles.some((profile) => profile.profileType === profileType);
};

export const isDuplicateProfileName = (profiles, profileName) => {
  return profiles.some((profile) => profile.profileName === profileName);
};

export const isCustomProfileNameValid = (useCustomName, customProfileName) => {
  if (useCustomName && customProfileName.trim() === "") {
      return "Custom profile name cannot be empty.";
  }
  return null;
};

    

 // * @param {File} file - The file to validate.
 // * @returns {boolean} - True if the file is an image, false otherwise.
 // */
export const isImageFile = (file) => {
   if (!file) return false;
   return file.type.startsWith("image/");
 };
  